"use strict";

exports.__esModule = true;
var _AlertWatcherRuleForm = require("./AlertWatcherRuleForm");
Object.keys(_AlertWatcherRuleForm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AlertWatcherRuleForm[key]) return;
  exports[key] = _AlertWatcherRuleForm[key];
});